module.exports = __webpack_public_path__ + "static/media/close.c332ba88.svg";